import { SBack, SMessage } from 'shj-components'
import { Button, message, Steps, Spin } from 'antd'
import { useSetState, useUpdateEffect } from 'ahooks'

import styles from './index.module.less'
import StepBaseInfo from './steps/step1'
import StepQuotaSpecs from './steps/step2'
import { useEffect, useMemo, useRef, useState } from 'react'
import StepPackageProduct from '@/pages/baseProduct/packageTemplate/addOrEdit/steps/step3'
import { useNavigate, useParams, useSearchParams } from 'react-router-dom'
import StepPackageSKU from '@/pages/baseProduct/packageTemplate/addOrEdit/steps/step4'
import {
  getPackModelDetail,
  GetTemplateCount,
  packModelSave,
  packModelTreeDetail,
  packModelUpdateById,
} from '@/services/product.ts'
import { cloneDeep } from "lodash-es";

const AddOrEditPackageTemp = () => {
  const { id } = useParams()
  const navigate = useNavigate()
  const [searchParams] = useSearchParams({})
  const step = searchParams.get('step')
  const cacheIdBySubPage = searchParams.get('cacheId')
  const editRef = useRef({ step1: {}, step2: {}, step3: {}, step4: {} })
  const [cacheId, setCacheId] = useState<any>(id)

  const [state, setState] = useSetState({
    current: step ? Number(step) : 0,
    isShowStep4: false,
    columnsConfig: [],
    btnLoading: false,
  })
  const [baseInfo, setBaseInfo] = useState<any>({}) // 打包模板基础数据

  useEffect(() => {
    getInfo()
  }, [])
  const getInfo = async () => {
    if (id) {
      const res: any = await getPackModelDetail({
        id: id,
        params: {
          queryTreeNodes: true,
          querySkus: true,
        },
      })
      console.log(res)
      const count =
        (await GetTemplateCount({
          data: { packModelId: id },
        })) || 0
      setBaseInfo({ ...res, linkStatus: Number(count) })
    }
  }
  useUpdateEffect(() => {
    console.log(baseInfo, '整体提交信息baseInfo')
  }, [baseInfo])

  const treeNodes = useMemo(() => {
     const filterTree = (treeData = [])  => {
      return treeData
        .filter(node => !(node.expirationTime || node.isExpire)) // 过滤当前层
        .map(node => ({
          ...node,
          children: node.children ? filterTree(node.children) : undefined // 递归处理子节点
        }));
    }
    console.log(baseInfo.treeNodes || [], 'treeNodes', 111 )
    return filterTree(cloneDeep(baseInfo.treeNodes || []))
  }, [baseInfo.treeNodes])

  const getStep4 = (SKUConfigure, specsFormItemList) => {
    if (SKUConfigure) {
      const isShowStep4 = SKUConfigure.some(item => item.data.length > 1)
      setState({ isShowStep4, columnsConfig: specsFormItemList })
    }
  }

  const stepList: any[] = [
    {
      subTitle: '基础信息',
      editRef: editRef.current.step1,
      components: (
        <StepBaseInfo
          baseInfo={baseInfo}
          setBaseInfo={(data: any) => setBaseInfo({ ...baseInfo, ...data })}
          setLoading={(btnLoading: boolean) => setState({ btnLoading })}
          cacheId={cacheId || cacheIdBySubPage}
          editRef={editRef.current.step1}
        />
      ),
    },
    {
      subTitle: '报价规格',
      editRef: editRef.current.step2,
      components: (
        <StepQuotaSpecs
          baseInfo={baseInfo}
          setBaseInfo={(data: any) => setBaseInfo({ ...baseInfo, ...data })}
          setLoading={(btnLoading: boolean) => setState({ btnLoading })}
          cacheId={cacheId || cacheIdBySubPage}
          editRef={editRef.current.step2}
          setStep={getStep4}
        />
      ),
    },
    {
      subTitle: '产品打包',
      editRef: editRef.current.step3,
      components: (
        <StepPackageProduct
          baseInfo={baseInfo}
          setBaseInfo={(data: any) => setBaseInfo({ ...baseInfo, ...data })}
          setLoading={(btnLoading: boolean) => setState({ btnLoading })}
          cacheId={cacheId}
          step1={editRef.current.step1}
          fetchApi={packModelTreeDetail}
          editRef={editRef.current.step3}
        />
      ),
    },
    {
      subTitle: 'SKU打包',
      editRef: editRef.current.step4,
      isControl: true,
      components: (
        <StepPackageSKU
          baseInfo={baseInfo}
          setLoading={(btnLoading: boolean) => setState({ btnLoading })}
          skuData={baseInfo.skuList}
          cacheId={cacheId}
          columnsConfig={state.columnsConfig}
          treeData={treeNodes}
          step2={editRef.current.step2}
          editRef={editRef.current.step4}
        />
      ),
    },
  ]

  const goBackPath = () => {
    const packHistoryPath = localStorage.getItem('packHistoryPath')
    if (packHistoryPath) {
      navigate(packHistoryPath)
    } else {
      navigate('/config/baseProduct/packageTemplate')
    }
    localStorage.removeItem('packHistoryPath')
    localStorage.removeItem('packTreeData')
  }

  const onNext = () => {
    const ref = stepList[state.current].editRef
    ref
      .onFinish()
      .then(res => {
        console.log(res, 'onNext---res')
        console.log(baseInfo, 'onNext---baseInfo')
        setBaseInfo({
          ...baseInfo,
          ...res,
        })
        state.current === 0 && setCacheId(res.id)
        setState({ current: state.current + 1 })
      })
      .finally(() => setState({ btnLoading: false }))
  }

  const onSubmit = () => {
    const ref = stepList[state.current].editRef
    setState({ btnLoading: true })
    ref
      .onFinish()
      .then(async res => {
        console.log(res, 'onSubmit---res')
        console.log(baseInfo, 'onSubmit---res')
        const submitInfo = { ...baseInfo, skuList: res ? [...res] : baseInfo.skuList }
        console.log(submitInfo, 'onSubmit---submitInfo')
        let api = submitInfo.id ? packModelUpdateById : packModelSave
        api({ ...submitInfo })
          .then(res => {
            message.success(res.message || '操作成功')
            goBackPath()
          })
          .finally(() => {
            setState({ btnLoading: false })
          })
      })
      .catch(() => setState({ btnLoading: false }))
  }

  const goBack = () => {
    SMessage.confirm({
      title: '确认继续返回',
      content: '返回将不会保存已添加信息',
      onOk: () => {
        navigate('/config/baseProduct/packageTemplate', { state: { saveCache: true }})
      },
    })
  }

  return (
    <SBack
      title={(id ? '编辑' : '新增') + '打包模板'}
      level={2}
      goPath={goBack}
      extra={[
        <Button loading={state.btnLoading} onClick={goBack}>
          取消
        </Button>,
        state.current > 0 && (
          <Button
            style={{ marginLeft: 10 }}
            onClick={() => setState({ current: state.current - 1 })}
          >
            上一步
          </Button>
        ),
        state.current + 1 < stepList.length ? (
          <Button type="primary" style={{ marginLeft: 10 }} onClick={onNext}>
            下一步
          </Button>
        ) : (
          <Button type="primary" style={{ marginLeft: 10 }} loading={state.btnLoading} onClick={onSubmit}>
            保存
          </Button>
        ),
      ]}
    >
      <Spin spinning={state.btnLoading}>
        <div className={styles.container}>
          <div className={styles.step_wrap}>
            <div className={styles.step_box} style={{ width: 800 }}>
              <Steps
                current={state.current}
                // labelPlacement={'vertical'}
                items={stepList.map(item => ({ key: item.subTitle, title: item.subTitle }))}
              />
            </div>
          </div>
          <div>
            {/*{stepList[state.current]?.components}*/}
            {stepList.map((item, i) => (
              <div key={i} style={{ display: state.current === i ? 'block' : 'none' }}>
                {item.components}
              </div>
            ))}
          </div>
        </div>
      </Spin>
    </SBack>
  )
}
export default AddOrEditPackageTemp
